var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { ContactType } from '../../constants/contactType.constants';
import BaseSelector from '../BaseSelector/BaseSelector';
export function ContactTypeSelector(p) {
    var contactTypeOptionsList = useMemo(function () {
        return ContactType.map(function (type) {
            return {
                label: type,
                value: type,
            };
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return React.createElement(Observer, { children: function () { return (React.createElement(BaseSelector, __assign({ className: "ContactTypeSelector" }, p, { options: contactTypeOptionsList, appearance: "system" }))); } });
}
export default ContactTypeSelector;
